import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from '../../config/firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import ComingSoon from './ComingSoon';

export default function MaintenanceGate({ currentUser, userRole, children }) {
  const location = useLocation();
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, 'settings', 'maintenance'),
      snap => {
        setSettings(snap.exists() ? snap.data() : { enabled: false });
        setLoading(false);
      },
      () => {
        // If we can't even read the setting, fail open rather than
        // locking everyone out by accident.
        setSettings({ enabled: false });
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  if (loading) return null;

  const isStaffOrAdmin = !!currentUser && (userRole === 'admin' || userRole === 'staff');
  const path = location.pathname;

  // Login and password reset must always stay reachable — otherwise
  // nobody could ever get in to turn maintenance mode back off.
  const alwaysAllowed = path === '/login' || path.startsWith('/reset-password');

  const chessAllowed = settings?.allowChess !== false && path.startsWith('/chess');

  const blocked = settings?.enabled && !isStaffOrAdmin && !alwaysAllowed && !chessAllowed;

  if (blocked) {
    return (
      <ComingSoon
        message={settings?.message}
        chessAllowed={settings?.allowChess !== false}
      />
    );
  }

  return children;
}
